export const projectBuilder = (obj) => {
    var _a, _b;
    return ({
        id: obj.id,
        projectNumber: obj.projectNumber,
        title: (_b = (_a = obj.metadata) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : "",
    });
};
export const roundBuilder = (obj) => ({
    id: obj.id,
    votes: obj.votes,
    uniqueContributors: obj.uniqueContributors,
    amountUSD: obj.amountUSD,
    matchAmount: obj.matchAmount,
    matchAmountUSD: obj.matchAmountUSD,
    applicationsStartTime: new Date(obj.applicationsStartTime * 1000),
    applicationsEndTime: new Date(obj.applicationsEndTime * 1000),
    roundStartTime: new Date(obj.roundStartTime * 1000),
    roundEndTime: new Date(obj.roundEndTime * 1000),
});
export const voteBuilder = (obj) => ({
    id: obj.id,
    projectId: obj.projectId,
    roundId: obj.roundId,
    token: obj.token,
    voter: obj.voter,
    grantAddress: obj.grantAddress,
    amount: obj.amount,
    amountUSD: obj.amountUSD,
});
export const roundApplicationBuilder = (obj) => ({
    id: obj.id,
    projectId: obj.projectId,
    roundId: obj.roundId,
    status: obj.status,
    payoutAddress: obj.payoutAddress,
    amountUSD: obj.amountUSD,
    votes: obj.votes,
    uniqueContributors: obj.uniqueContributors,
});
export const roundMatchBuilder = (obj) => ({
    totalReceived: obj.totalReceived,
    sumOfSqrt: obj.sumOfSqrt,
    matched: obj.matched,
    projectName: obj.projectName,
    payoutAddress: obj.payoutAddress,
    contributionsCount: obj.contributionsCount,
    projectId: obj.projectId,
    applicationId: obj.applicationId,
});
